import { useEffect, useState } from 'react';
import type { ProductCategory } from '../../types';
import './MultiCategoryFilter.css';

interface MultiCategoryFilterProps {
  categories: ProductCategory[];
  selectedCategories: string[];
  onCategoriesChange: (categories: string[]) => void;
}

const MultiCategoryFilter: React.FC<MultiCategoryFilterProps> = ({
  categories,
  selectedCategories,
  onCategoriesChange,
}) => {
  const [allSelected, setAllSelected] = useState(false);

  useEffect(() => {
    setAllSelected(selectedCategories.length === categories.length && categories.length > 0);
  }, [selectedCategories, categories]);

  const handleCategoryToggle = (categoryName: string) => {
    if (selectedCategories.includes(categoryName)) {
      onCategoriesChange(selectedCategories.filter(c => c !== categoryName));
    } else {
      onCategoriesChange([...selectedCategories, categoryName]);
    }
  };

  const handleSelectAll = () => {
    if (allSelected) {
      onCategoriesChange([]);
    } else {
      onCategoriesChange(categories.map(c => c.name));
    }
    setAllSelected(!allSelected);
  };

  const handleClear = () => {
    onCategoriesChange([]);
  };

  return (
    <div className="multi-category-filter">
      <div className="multi-category-filter__header">
        <label className="multi-category-filter__label">商品分類</label>
        <div className="multi-category-filter__actions">
          <button
            className="multi-category-filter__action-btn"
            onClick={handleSelectAll}
            type="button"
          >
            {allSelected ? '取消全選' : '全選'}
          </button>
          {selectedCategories.length > 0 && (
            <button
              className="multi-category-filter__action-btn"
              onClick={handleClear}
              type="button"
            >
              清除
            </button>
          )}
        </div>
      </div>
      <div className="multi-category-filter__list">
        {categories.map((category) => (
          <label key={category.id} className="multi-category-filter__item">
            <input
              type="checkbox"
              className="multi-category-filter__checkbox"
              checked={selectedCategories.includes(category.name)}
              onChange={() => handleCategoryToggle(category.name)}
            />
            <span className="multi-category-filter__category-name">
              {category.name}
            </span>
            <span className="multi-category-filter__count">
              ({category.productCount || 0})
            </span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default MultiCategoryFilter;
